import React, { Children, useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    create_edit_faq_ques_list_actionHandler,
    delete_ques_list_actionHandler,
    update_parent_ques_list_actionHandler,
} from '../../../../../Redux/Actions/user/CreateUploadFAQ';
import { DownOutlined } from '@ant-design/icons';
import '../ResourceStyle.css';

import {
    Badge,
    Dropdown,
    Button,
    Space,
    Table,
    Drawer,
    Form,
    Input,
    Modal,
    message,
    Spin,
} from 'antd';

import { CloseOutlined } from '@ant-design/icons';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from "@juniyadi/ckeditor5-custom-build";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEdiorConfig } from '../../../../../Config/CKEdiorConfig';
const EditFAQ = () => {
    const dispatch = useDispatch();
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [selectedSubRecord, setSelectedSubRecord] = useState(null);
    const [selectedRowData, setSelectedRowData] = useState(null);

    const [answerTouched, setAnswerTouched] = useState(false);
    const handleRowExpand = (expanded, record, index) => {
        setExpandedRowKeys(expanded ? [record.key] : []);
    };
    const showSidebar = (record, value) => {
        setSelectedRowData({ ...record, additionalValue: value });

        setIsSidebarVisible(true);
    };
    const editorRef = useRef();
    const rows = 10;
    const DataforTable = useSelector(
        (state) => state.create_quest_list_data?.create_quest_list_data?.data
    );
    const CreateLoader = useSelector(
        (state) => state.create_quest_list_data.loader
    );
    const updateData = useSelector((state) => state.edit_parent_ques_list_data);
    const loader = useSelector(
        (state) => state.edit_parent_ques_list_data.loader
    );
    const deleteData = useSelector((state) => state.delete_ques_list_data);
    const deleteDataLoader = useSelector(
        (state) => state.delete_ques_list_data.loader
    );
    const onChangeCkEditor = (event, editor) => {
        const data = editor.getData();
        setAnswer(data);
        // onChange(data);
    };
    const transformData = (data) => {
        const transformed = [];

        data?.forEach((topic) => {
            topic.questions.forEach((question) => {
                const row = {
                    key: question.id,
                    parent_question: question.question,
                    parent_answer: question.answer,
                    topic_name: topic.topic_name,
                    children: question.children,
                    id: topic.id,
                };
                transformed.push(row);
            });
        });
        return transformed;
    };

    const DataforTablee = transformData(DataforTable);

    const [editingRowData, setEditingRowData] = useState(null);
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    const [isSubSidebarVisible, setIsSubSidebarVisible] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [deleteSubModalVisible, setDeleteSubModalVisible] = useState(false);
    const [answer, setAnswer] = useState(selectedRowData?.parent_answer);

    const showSubSidebar = (record, value) => {
        setEditingRowData({ ...record, additionalValue: value });

        setIsSubSidebarVisible(true);
    };
    const hideSidebar = () => {
        setIsSidebarVisible(false);
    };
    const handleDeleteClick = (record) => {
        setSelectedRecord(record);
        setDeleteModalVisible(true);
    };
    const handleSubDeleteClick = (record) => {
        setSelectedSubRecord(record);
        setDeleteSubModalVisible(true);
    };

    const handleDeleteCancel = () => {
        setDeleteModalVisible(false);
    };
    const hideSubSidebar = () => {
        setIsSubSidebarVisible(false);
    };
    const handleDeleteConfirm = () => {
        if (selectedRecord) {
            dispatch(delete_ques_list_actionHandler(selectedRecord.key));
            if (deleteData.error) {
                message.error('Something went wrong');
            } else {
                message.success('Deleted Successfully');
            }
        }
        setDeleteModalVisible(false);
    };
    const handleInputChange = (e) => {
        setEditingRowData((prevData) => ({
            ...prevData,
            question: e.target.value,
        }));
    };

    const handleAnswerChange = (e) => {
        setEditingRowData((prevData) => ({
            ...prevData,
            answer: e.target.value,
        }));
    };
    const handleTopicChange = (e) => {
        setSelectedRowData((prevData) => ({
            ...prevData,
            topic_name: e.target.value,
        }));
    };

    const handleParentQuesChange = (e) => {
        setSelectedRowData((prevData) => ({
            ...prevData,
            parent_question: e.target.value,
        }));
    };
    const handleParentAnswerChange = (e) => {
        setSelectedRowData((prevData) => ({
            ...prevData,
            parent_answer: e.target.value,
        }));
    };
    const handleSubDeleteConfirm = () => {
        if (selectedSubRecord) {
            dispatch(delete_ques_list_actionHandler(selectedSubRecord.id));
            if (deleteData.error) {
                message.error('Something went wrong');
            } else {
                message.success('Deleted Successfully');
            }
        }
        setDeleteSubModalVisible(false);
    };
    const handleSubDeleteCancel = () => {
        setDeleteSubModalVisible(false);
    };

    const handleUpdateParent = () => {
        if (answer === undefined) {
            setAnswer(selectedRowData?.parent_answer);
        }

        if (selectedRowData) {
            const payloadParent = {
                topic_name: selectedRowData.topic_name || '',
                question_id: selectedRowData.key,
                question: selectedRowData.parent_question,
                answer: answer,
                parent_question_id: null,
                topic_id: selectedRowData.id,
                question_type: selectedRowData.additionalValue || null,
            };

            // Dispatch action to update the parent data
            dispatch(update_parent_ques_list_actionHandler(payloadParent));
            if (updateData.error) {
                message.error('Something went wrong');
            } else {
                message.success('Updated successfully');
            }
        }

        hideSidebar();
    };

    const handleUpdateSub = () => {
        if (editingRowData) {
            const payloadsub = {
                topic_name: editingRowData.topic_name || '',
                question_id: editingRowData.id,
                question: editingRowData.question,
                answer: answer,
                parent_question_id: editingRowData.question_id,
                topic_id: editingRowData.topic_id,
                question_type: editingRowData.additionalValue || null,
            };
            dispatch(update_parent_ques_list_actionHandler(payloadsub));
            if (updateData.error) {
                message.error('Something went wrong');
            } else {
                message.success('Updated successfully');
            }

            hideSubSidebar();
        }
    };
    useEffect(() => {
        setAnswer(selectedRowData?.parent_answer);
        dispatch(create_edit_faq_ques_list_actionHandler());
    }, [dispatch]);
    const expandedRowRender = (records) => {
        const columns = [
            {
                title: 'Sub-Question',
                dataIndex: 'question',
                key: 'question',
            },
            {
                title: 'Answer',
                dataIndex: 'answer',
                key: 'answer',
                render: (text) => (
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                ),
            },
            {
                title: 'Action',
                key: 'operation',

                render: (record) => (
                    <Space size='middle'>
                        <a onClick={() => showSubSidebar(record, 'sub')}>
                            Edit
                        </a>
                        <a
                            href='#'
                            style={{ cursor: 'pointer !important' }}
                            onClick={() => handleSubDeleteClick(record)}>
                            Delete
                        </a>
                    </Space>
                ),
            },
        ];

        const ChildrenData = records.children?.map((data) => ({
            question: data.question,
            answer: data.answer,
            topic_id: records.id,
            topic_name: records.topic_name,
            question_id: records.key,
            id: data.id,
        }));

        return (
            <Table
                columns={columns}
                dataSource={ChildrenData}
                pagination={false}
            />
        );
    };

    const columns = [
        {
            title: 'Parent Question',
            dataIndex: 'parent_question',
            key: 'question',
        },
        {
            title: 'Parent Answer',
            dataIndex: 'parent_answer',
            key: 'answer',
            render: (text) => (
                <div dangerouslySetInnerHTML={{ __html: text }} />
            ),
        },
        {
            title: 'Topic',
            dataIndex: 'topic_name',
            key: 'topic_name',
        },
        {
            title: 'Action',
            key: 'operation',
            render: (record) => (
                <Space size='middle'>
                    <a onClick={() => showSidebar(record, 'parent')}>Edit</a>
                    <a
                        href='#'
                        style={{ cursor: 'pointer !important' }}
                        onClick={() => handleDeleteClick(record)}>
                        Delete
                    </a>
                </Space>
            ),
        },
    ];
    return (
        <div>
            {loader && (
                <div className='spinner'>
                    {' '}
                    <Spin />
                </div>
            )}

            {CreateLoader && (
                <div className='spinner'>
                    {' '}
                    <Spin />
                </div>
            )}
            {deleteDataLoader && (
                <div className='spinner'>
                    {' '}
                    <Spin />
                </div>
            )}

            <Table
                className='table-ma'
                columns={columns}
                expandable={{
                    expandedRowRender,
                    expandedRowKeys,
                    onExpand: handleRowExpand,
                }}
                dataSource={DataforTablee}
                size='small'
            />

            {/* drawer for sub */}

            <Drawer
                title='Edit'
                placement='right'
                record={selectedSubRecord}
                closable={true}
                onClose={hideSidebar}
                visible={isSubSidebarVisible}
                width={500}>
                <div className='new-btn'>
                    <h2>Edit FAQs</h2>
                    <Button
                        className='close-btn'
                        type='text'
                        placement='right'
                        shape='circle'
                        icon={<CloseOutlined />}
                        size='large'
                        onClick={hideSubSidebar}
                    />
                </div>
                <div className='main-div'>
                    <div>
                        <Form>
                            <div className='video-input-field'>
                                <label>Sub-Question</label>
                                <Input
                                    onChange={handleInputChange}
                                    value={editingRowData?.question}
                                    placeholder='Sample'
                                />
                            </div>
                            <div className='video-input-field'>
                                <label>Answer</label>
                                {/*<Input value={editingRowData?.answer} onChange={handleAnswerChange} placeholder='Sample' />*/}
                                {editingRowData && (
                                    <>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            placeholder='Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime non distinctio recusandae.'
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                onChangeCkEditor(event, editor);
                                            }}
                                            style={{ height: `${rows * 25}px` }}
                                            data={editingRowData?.answer || ''} // Use data prop instead of value prop
                                            ref={editorRef}
                                            config={{ toolbar: CKEdiorConfig }}
                                        />
                                    </>
                                )}
                            </div>

                            <div className='upload'>
                                <button
                                    onClick={handleUpdateSub}
                                    className='upload-button'>
                                    Save Changes
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </Drawer>

            {/* drawer for parent  */}

            <Drawer
                title='Edit'
                placement='right'
                record={selectedRecord}
                closable={true}
                onClose={hideSidebar}
                visible={isSidebarVisible}
                width={500}>
                <div className='new-btn'>
                    <h2>Edit FAQs</h2>
                    <Button
                        className='close-btn'
                        type='text'
                        placement='right'
                        shape='circle'
                        icon={<CloseOutlined />}
                        size='large'
                        onClick={hideSidebar}
                    />
                </div>
                <div className='main-div'>
                    <div>
                        <Form>
                            <div className='video-input-field'>
                                <label>Topic</label>
                                <Input
                                    onChange={handleTopicChange}
                                    value={selectedRowData?.topic_name || ''}
                                    placeholder='Sample'
                                />
                            </div>
                            <div className='video-input-field'>
                                <label>Parent Question</label>
                                <Input
                                    onChange={handleParentQuesChange}
                                    value={selectedRowData?.parent_question}
                                    placeholder='Sample'
                                />
                            </div>
                            <div className='video-input-field'>
                                <label>Parent Answer</label>
                                {/* <Input
                                    onChange={handleParentAnswerChange}

                                    value={selectedRowData?.parent_answer}

                                    placeholder='Sample' /> */}

                                {selectedRowData && (
                                    <>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            placeholder='Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime non distinctio recusandae.'
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                onChangeCkEditor(event, editor);
                                            }}
                                            style={{ height: `${rows * 25}px` }}
                                            data={
                                                selectedRowData?.parent_answer ||
                                                ''
                                            } // Use data prop instead of value prop
                                            ref={editorRef}
                                            config={{ toolbar: CKEdiorConfig }}
                                        />
                                    </>
                                )}
                            </div>

                            <div className='upload'>
                                <button
                                    onClick={handleUpdateParent}
                                    type='submit'
                                    className='upload-button'>
                                    Save Changes
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </Drawer>

            <Modal
                title='Confirm Delete'
                visible={deleteModalVisible}
                onCancel={handleDeleteCancel}
                onOk={handleDeleteConfirm}
                okText='Delete'
                cancelText='Cancel'
                okButtonProps={{
                    style: { backgroundColor: 'red', borderColor: '#ff4d4f' },
                }}>
                <p>Are you sure you want to delete this item?</p>
            </Modal>

            <Modal
                title='Confirm Delete'
                visible={deleteSubModalVisible}
                onCancel={handleSubDeleteCancel}
                onOk={handleSubDeleteConfirm}
                okText='Delete'
                cancelText='Cancel'
                okButtonProps={{
                    style: { backgroundColor: 'red', borderColor: '#ff4d4f' },
                }}>
                <p>Are you sure you want to delete this item?</p>
            </Modal>
        </div>
    );
};
export default EditFAQ;
